import { CCol, CInput, CLabel, CRow } from "@coreui/react";
import React from "react";
import { formatDate } from "src/shared/Format/dateFormat";

const LotListViewTenderDetails = (props) => {
  return (
    <>
      <CRow className="pt-3" xl={12}>
        <CCol className="mb-2" xl={12}>
          <h3 className="titlehr">Tender Details</h3>
        </CCol>
      </CRow>

      <div className="pl-1 pr-1">
        <CRow>
          <CCol className="mb-2" xl={4}>
            <CLabel htmlFor="exampleFormControlInput1">Tender number :</CLabel>
            <CInput
              value={
                props.viewTenderDetails.tenderNo === null
                  ? " "
                  : props.viewTenderDetails.tenderNo
              }
              disabled
              id="exampleFormControlInput1"
            />
          </CCol>
          <CCol className="mb-2" xl={4}>
            <CLabel htmlFor="exampleFormControlInput1">Details :</CLabel>
            <CInput
              value={
                props.viewTenderDetails.details === null
                  ? " "
                  : props.viewTenderDetails.details
              }
              disabled
              id="exampleFormControlInput1"
            />
          </CCol>
          <CCol className="mb-2" xl={4}>
            <CLabel htmlFor="exampleFormControlInput1">Publish Date :</CLabel>
            <CInput
              value={
                props.viewTenderDetails.purchaseDate === null
                  ? " "
                  : formatDate(props.viewTenderDetails.purchaseDate)
              }
              disabled
              id="exampleFormControlInput1"
            />
          </CCol>
        </CRow>
        <CRow>
          <CCol className="mb-2" xl={4}>
            <CLabel htmlFor="exampleFormControlInput1">Rebate(%) :</CLabel>
            <CInput
              value={
                props.viewTenderDetails.rebate === null
                  ? " "
                  : props.viewTenderDetails.rebate
              }
              disabled
              id="exampleFormControlInput1"
            />
          </CCol>
          <CCol className="mb-2" xl={4}>
            <CLabel htmlFor="exampleFormControlInput1">
              Late Fee Per Day(%) :
            </CLabel>
            <CInput
              value={
                props.viewTenderDetails.lateFeePerDay === null
                  ? " "
                  : props.viewTenderDetails.lateFeePerDay
              }
              disabled
              id="exampleFormControlInput1"
            />
          </CCol>
          <CCol className="mb-2" xl={4}>
            <CLabel htmlFor="exampleFormControlInput1">
              Security Deposit Amount :
            </CLabel>
            <CInput
              value={
                props.viewTenderDetails.securityDepositAmount === null
                  ? " "
                  : props.viewTenderDetails.securityDepositAmount
              }
              disabled
              id="exampleFormControlInput1"
            />
          </CCol>
        </CRow>
        <CRow>
          <CCol className="mb-2" xl={4}>
            <CLabel htmlFor="exampleFormControlInput1">
              Security Deposit Day :
            </CLabel>
            <CInput
              value={
                props.viewTenderDetails.securityDepositDay === null
                  ? " "
                  : props.viewTenderDetails.securityDepositDay
              }
              disabled
              id="exampleFormControlInput1"
            />
          </CCol>
          <CCol className="mb-2" xl={4}>
            <CLabel htmlFor="exampleFormControlInput1">Total Lots :</CLabel>
            <CInput
              value={
                props.viewTenderDetails.totalLots === null
                  ? " "
                  : props.viewTenderDetails.totalLots
              }
              disabled
              id="exampleFormControlInput1"
            />
          </CCol>
          <CCol className="mb-2" xl={4}>
            <CLabel htmlFor="exampleFormControlInput1">
              Collection Season :
            </CLabel>
            <CInput
              value={
                props.viewTenderDetails.collectionSeason === null
                  ? " "
                  : props.viewTenderDetails.collectionSeason
              }
              disabled
              id="exampleFormControlInput1"
            />
          </CCol>
        </CRow>
      </div>
    </>
  );
};

export default LotListViewTenderDetails;
